import React from "react";
import { Timeline } from "antd";
import PageHeader from "../../Common/PageHeader/PageHeader";

const ChangelogInfo = () => {
  return (
    <>
      <PageHeader text="Лог на промените" />
      <Timeline
        className="chagelog-timeline"
        items={[
          {
            color: "gray",
            children: (
              <>
                <h3>11.10.2024</h3>

                <p>
                  📏 Добавени вариации в MyMenu – пример: избор на размер,
                  тесто, борд на пица
                </p>
                <p>
                  💳 Добавена възможност за разделяне на сметка и плащане –
                  клиентите могат да избират каква част от сметката да платят
                </p>
                <p>
                  🖥️ Поръчки от MyMenu се визуализират с иконки на монитор кухня
                </p>
                <p>
                  📝 Добавени анкети – бутон "Оцени ни", където клиентите могат
                  да оставят отзив в Google Reviews
                </p>
                <p>🗂️ Диспечер "Архив поръчки" – оптимизация</p>
                <p>🔍 Подобрено търсене в MyMenu Портал</p>
                <p>
                  🛠️ Права на потребители – възможност всеки потребител да си
                  конфигурира собствените заведения
                </p>
                <p>📋 Нова страница в табличен вид с резервации</p>
                <p>
                  📱 Нови изгледи при създаване на резервация за таблет и
                  телефон
                </p>
                <p>⏰ Автоматично освобождаване на всички всяка сутрин</p>
                <p>
                  📲 Изпращане на SMS при създаване на нова резервация и
                  напомняне един час преди нея
                </p>
                <p>🔲 Добавена опция за работа във Fullscreen в резервациите</p>
              </>
            ),
          },

          {
            color: "gray",
            children: (
              <>
                <h3>29.09.2024</h3>

                <p>
                  👨‍🍳 Добавена нова роля в Деливери портала – Шофьор (може само
                  да приема поръчки)
                </p>
                <p>💼 Добавена опция за фактура в Delivery</p>
                <p>
                  📸 Снимката в MyMenu може да стане линк и да води към промоция
                </p>
                <p>
                  💳 Премахване на минимална сума на плащане на сметки в MyMenu
                </p>
                <p>📅 Показване на дневно меню от TouchSale</p>
                <p>🎨 Визуални подобрения в ListView режима на работа Портал</p>
                <p>🕒 Конфигурация на работно време на ниво заведение</p>
                <p>
                  🪑 Подсказване на подходяща маса при избор на хора – масите
                  светват ако са 3-ма човека, за 4 човека, 5 за 6 и т.н.
                </p>
                <p>🟥 Оцветяване на маси един час преди резервацията</p>
                <p>
                  📊 Нова справка за отминали и предстоящи резервации в табличен
                  вид
                </p>
                <p>🛠️ Нова страница "UnrealSoft администратор"</p>
                <p>🐞 Оправен проблем при сканиране на маси</p>
              </>
            ),
          },

          {
            color: "gray",
            children: (
              <>
                <h3>08.09.2024</h3>

                <p>
                  🔖 Добавена нова функционалност за филтриране на ястия по тип
                  (вегетариански, без глутен и др.)
                </p>
                <p>🍰 Подобрено визуално оформление на десертите и напитките</p>
                <p>
                  🎁 Нов начин на работа със специални оферти и промоции –
                  клиентите могат да видят специални предложения при преглед на
                  менюто Портал
                </p>
                <p>
                  🚚 Нови права за управление на доставки в портала – нови
                  възможности за управление на статуса на доставките и тяхната
                  проследяемост
                </p>
                <p>🖼️ Подобрено управление на снимки и медии в портала</p>
                <p>
                  🎨 Дизайнерски подобрения на потребителския интерфейс в
                  портала
                </p>
                <p>🔎 Нови филтри за справки по обекти и менюта в портала</p>
                <p>⚙️ Оптимизация на администраторския интерфейс в портала</p>
              </>
            ),
          },

          {
            color: "gray",
            children: (
              <>
                <h3>19-08-2024</h3>

                <p>📅 Резервации:</p>
                <ul>
                  <li>
                    Схема на заведението: Конфигуриране на маси с размери,
                    места, форма
                  </li>
                  <li>Резервации: Създаване и управление на резервациите</li>
                </ul>
                <p>
                  🖨️ Печат на поръчки по монитори в кухня от MyMenu и MyDelivery
                </p>
                <p>👥 Добавени нови типове потребители с ограничен достъп</p>
                <p>
                  ⚙️ Оптимизиране на MyMenu картите при дълги текстове
                  Оптимизиране изгледа на MyMenu при работа без снимки
                </p>
                <p>📱 QR управление:</p>
                <ul>
                  <li>Нов QR генератор</li>
                  <li>Добавено сортиране и търсене по маси</li>
                  <li>
                    Нов бутон "Опресни меню", който синхронизира промените от
                    TouchSale
                  </li>
                </ul>
                <p>📸 Снимки и медия:</p>
                <ul>
                  <li>
                    Синхронизиране на снимките веднъж дневно или при промяна
                  </li>
                  <li>Увеличаване резолюцията на снимките</li>
                </ul>
                <p>
                  🛠️ Добавяне на опция автоматично приемане на поръчки:
                  Проверява съответната маса в кой район е, след което кои
                  сервитьори отговарят за този район и изпраща сметката към тях
                </p>
                <p>💳 Плащания:</p>
                <ul>
                  <li>
                    Добавена опция как ще бъде платена поръчката от Delivery - в
                    брой/с карта
                  </li>
                  <li>Добавено разделяне на сметка при плащане</li>
                </ul>
                <p>💰 Добавяне работа с конкретни ценови листи</p>
                <p>🌍 Добавена възможност за работа в Румъния</p>
                <p>📊 Справка изпълнение на доставки</p>
                <p>
                  🍽️ Добавена MyMenu отметка в добавките, дали са активни за
                  MyMenu или не
                </p>
                <p>🐞 Отстранен бъг в работата с добавки</p>
              </>
            ),
          },

          {
            color: "gray",
            children: (
              <>
                <h3>20-03-2024</h3>
                <p>🔥 Нов начин на работа на добавките</p>
                <ul>
                  <li>основни (както работят и в момента)</li>
                  <li>
                    пожелателни (при добавяне на ястие с добавки, приложението
                    подканва клиента да избере от пожелателните такива)
                  </li>
                  <li>
                    задължителни (при добавяне на ястие с добавки, приложението
                    задължава клиента да избере от задължителните такива)
                  </li>
                </ul>

                <p>🆕 Нови изгледи на MyMenu</p>
                <p>🆕 Скриване на линка след сканиране на QR</p>
                <p>🆕 Поръчки без потвърждение на сервитьор</p>
                <p>🆕 Поръчки към предварително зададени райони и бригади</p>
                <p>🆕 Скриване на менюто след 45 минути неактивност</p>
                <p>
                  🆕 Добавени настройки за активност на групи и модификатори за
                  MyMenu
                </p>
                <p>🆕 Конфигурация на тагове през портала</p>
                <p>💄 Обновяване страницата с алергените</p>
                <p>💄 Обновяване страницата меню конфигурация</p>
                <p>🐞 Отстранен бъг в използването на отстъпките</p>
              </>
            ),
          },

          {
            color: "gray",
            children: (
              <>
                <h3>19-02-2024</h3>
                <p>
                  🆕 Нов изглед за MyMenu -{">"} големи снимки на групите,
                  Floating слайдер с групите докато се разглежда менюто
                </p>
                <p>🆕 Нови шрифтове за текстовете в MyMenu</p>
                <p>
                  🆕 Добавена анимация при първоначалното зареждане на менюто
                </p>
                <p>🆕 Увеличаване качеството на снимките в MyMenu</p>
                <p>🆕 Следене наличности на асортименти от TouchSale</p>
                <p>
                  🆕 Добаяне на тагове/баджове на ястията (ново, сезонно, люто и
                  др.)
                </p>
                <p>
                  🆕 Добавени нови функционалности в портала свързани с
                  използваните отстъпки в MyMenu, нови филтри
                </p>
                <p>
                  🆕 Добавени визуални ефекти при показването на динамичните
                  елементи в MyMenu
                </p>
                <p>🐞 Оптимизиране бързината на MyMenu</p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>03-01-2024</h3>
                <p>🆕 Нови цветови теми за MyMenu</p>
                <p>🆕 Подобрено добавянето на коментар в MyMenu</p>
                <p>🆕 Добавяне на анкети в TouchSale Portal</p>
                <p>🆕 Нова справка "Справка отчети" в TouchSale Portal</p>
                <p>🆕 Нова справка "Справка доставки" в TouchSale Portal</p>
                <p>
                  🐞 Оптимизиране на "Справка по асортименти" в TouchSale Portal
                </p>
                <p>🐞 Оптимизиране на "Справка по маси" в TouchSale Portal</p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>29-11-2023</h3>
                <p>🆕 "Справка изпълнение на доставки"</p>
                <p>🆕 "Обороти по видове плащания в "Справка по обекти"</p>
                <p>🆕 Добавен Google преводач в MyMenu</p>
                <p>🆕 Обновяване дизайна на MyMenu</p>
                <p>
                  🆕 Добавена статистика за сканирането на кодове в страницата
                  "QR управление"
                </p>
                <p>🆕 Нов режим на работа на MyMenu - Само разглеждане</p>
                <p>🆕 Нов режим на работа на MyMenu - Предварителна поръчка</p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>09-11-2023</h3>
                <p>
                  🆕 "Справка по сервитьори" - статистика за видовете плащания
                </p>
                <p>🆕 "Справка по обекти" - статистика за видовете плащания</p>
                <p>🆕 Промени в графиките на "Дашборда"</p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>25-10-2023</h3>
                <p>🐞 Корекции при зареждане на данни</p>
                <p>🐞 Промени в "Справки по маси"</p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>23-09-2023</h3>
                <p>🐞 Корекции при зареждане на данни</p>
                <p>🆕 Отчети за Отворени/Затворени Маси</p>
                <p>🆕 Добавено сортиране на групи и продукти</p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>16-10-2023</h3>
                <p>🐞 Отстранен проблем в някои справки при работа</p>
                <p>🐞 Справка по маси - оправени сумите</p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>12-10-2023</h3>
                <p>
                  🆕 Добавена нова статистика за последните 8 дни в началната
                  страница
                </p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>12-10-2023</h3>
                <p>🐞 Отстранен проблем при работа с MyMenu</p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>9-10-2023</h3>
                <p>
                  🆕 Добавена нова статистика за последните 8 дни в началната
                  страница
                </p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>6-10-2023</h3>
                <p>🐞 Корекции в Справка по сервитьори</p>
                <p>🆕 Нови фукнции за управление на отстъпките</p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>3-10-2023</h3>
                <p>🐞 Отстранени проблеми предходната версия</p>
                <p>🆕 Синхронизиране на отстъпките с TouchSale</p>
                <p>
                  🆕 Следене наличности на продукти от TouchSale Отстранени
                  проблеми предходната версия
                </p>
              </>
            ),
          },
          {
            color: "gray",
            children: (
              <>
                <h3>27-09-2023</h3>
                <p>🆕 Добавени тагове в MyMenu</p>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default ChangelogInfo;
